module.exports = __webpack_public_path__ + "static/media/yellowmachine--main.d09bc254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/yellowmachine/yellowmachine--main.jpg
// module id = 173
// module chunks = 0